import React, { useEffect } from "react";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Button, Row, Col, Checkbox } from "antd";
import styles from './styles.module.css'
import { messages } from "../../../../lib/vaildations";
import { isValidPhoneNumberRegex } from "../../../../utils/";

const PersonalInformation = (props) => {
  const { form, nextStep, data, states } = props;

  const { getFieldDecorator, setFieldsValue } = form;
  useEffect(() => {
    setFieldsValue({
      ...data,
    });
  }, [data]);
  return (
    <div>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="First Name">
            {getFieldDecorator("firstName", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(<Input placeholder="First Name " />)}
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label="Last Name">
            {getFieldDecorator("lastName", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(<Input placeholder="Last Name" />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="Email">
            {getFieldDecorator("email", {
              rules: [
                {
                  type: "email",
                  message: messages.email,
                },
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(<Input placeholder="E-Mail Address" />)}
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Password">
            {getFieldDecorator("password", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
                {
                  min: 8,
                  message: messages.passwordLength,
                },
              ],
            })(<Input.Password placeholder="Password" />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Phone">
            {getFieldDecorator("phone", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
                {
                  pattern: new RegExp(isValidPhoneNumberRegex),
                  message: messages.phone,
                },
              ],
            })(<Input placeholder="Cell Phone Number" />)}
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label="Home Street">
            {getFieldDecorator("homeStreet", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(<Input placeholder="Home Street Address?" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Home City">
            {getFieldDecorator("homeCity", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(<Input placeholder="Home City" />)}
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Home State">
            {getFieldDecorator("homeState", {
              rules: [{ required: true, message: messages.required }],
            })(
              <Select
                showSearch
                placeholder="Please Select A State"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {!states.loading &&
                  states.data.states.map((state) => (
                    <Option key={state.id} value={state.sName}>
                      {state.name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="Home Zip Code">
            {getFieldDecorator("homeZipCode", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
                {
                  pattern: new RegExp("^([0-9]{5})(?:[-s]*([0-9]{4}))?$"),
                  message: messages.zip,
                },
              ],
            })(<Input placeholder="Home Zip Code" />)}
          </Form.Item>
        </Col>
      </Row>

      <div className={styles.ButtonsContainer}>
        <Button type="primary" onClick={nextStep}>
          Next Step
        </Button>
      </div>
    </div>
  );
};

export default PersonalInformation;
